import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useApi } from "../../context/ApiProvider";
import Card from "../Helpers/Card";

export default function Exports({ client }) {
  const Api = useApi();
  const { clientId } = useParams();
  const [isExportingRolfings, setIsExportingRolfings] = useState(false);
  const [isExportingGoals, setIsExportingGoals] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const resetMessages = () => {
    setError(false);
    setSuccess(false);
  };

  const downloadWorkbook = async (path, sheetName) => {
    const payload = await Api.get(`${path}${path.includes('?') ? '&' : '?'}format=json`);
    const XLSXModule = await import('xlsx');
    const XLSX = XLSXModule.default || XLSXModule;
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([payload.header || [], ...(payload.rows || [])]);
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    const workbookArray = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob(
      [workbookArray],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
    );
    const objectUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = payload.filename || `${sheetName}.xlsx`;
    anchor.rel = 'noopener';
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.setTimeout(() => {
      window.URL.revokeObjectURL(objectUrl);
    }, 1000);
    return payload;
  };

  const exportRolfings = async () => {
    resetMessages();
    setIsExportingRolfings(true);
    try {
      await downloadWorkbook(`/clients/${clientId}/exports/rolfings`, 'Rolfings');
      setSuccess('Rolfing export downloaded successfully.');
    } catch (e) {
      setError(e?.error || 'Failed to export rolfing data.');
    } finally {
      setIsExportingRolfings(false);
    }
  };

  const exportGoals = async () => {
    resetMessages();
    setIsExportingGoals(true);
    try {
      await downloadWorkbook(`/clients/${clientId}/exports/goals`, 'Goals');
      setSuccess('Goal and key result export downloaded successfully.');
    } catch (e) {
      setError(e?.error || 'Failed to export goals and key results.');
    } finally {
      setIsExportingGoals(false);
    }
  };

  return (
    <div className="grid-container">
      <section>
        <h4>Exports{client?.name ? ` for ${client.name}` : ''}</h4>
        <p>Export data as Excel workbooks.</p>

        {success ? <p className="formControlSuccess">{success}</p> : null}
        {error ? <p className="formControlError">{error}</p> : null}

        <div className="grid-container">
          <section>
            <h5>Rolfings</h5>
            <Card>
              <p>Exports all rolfings for this client in a readable long-form format, including who performed the rolfing, who it is connected to, template name, every step, step values, step notes, and overall notes/actions.</p>
              <input
                type="button"
                value={isExportingRolfings ? 'Preparing export...' : 'Export rolfings to Excel'}
                onClick={exportRolfings}
                disabled={isExportingRolfings || isExportingGoals}
              />
            </Card>
          </section>

          <section>
            <h5>Goals and key results</h5>
            <Card>
              <p>Exports all goals and key results for this client, including current metadata and any recorded key result history entries.</p>
              <input
                type="button"
                value={isExportingGoals ? 'Preparing export...' : 'Export goals and key results to Excel'}
                onClick={exportGoals}
                disabled={isExportingGoals || isExportingRolfings}
              />
            </Card>
          </section>
        </div>
      </section>
    </div>
  );
}
